import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_SelfAdministeredMedObservation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_SelfAdministeredMedObservation' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><center><h3>Self-Administered Medication Observation Log</h3></center>
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Name</span> </td>
                        <td className='w-250'> <span className='eleHeader'>ID Number</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Program</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIdNumber' name='txtIdNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtProgram' name='txtProgram' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Time</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Medication</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Dosage</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Individual Signature</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Staff Observation Signature/Credential</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_1' name='txtTime_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_2' name='txtTime_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_3' name='txtTime_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_4' name='txtTime_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_5' name='txtTime_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_5' name='txtDate_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_6' name='txtTime_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_6' name='txtDate_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_7' name='txtTime_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_7' name='txtDate_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_7' name='txtMedication_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_7' name='txtDosage_7' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_8' name='txtTime_8' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_8' name='txtDate_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_8' name='txtMedication_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_8' name='txtDosage_8' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_9' name='txtTime_9' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_9' name='txtDate_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_9' name='txtMedication_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_9' name='txtDosage_9' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_10' name='txtTime_10' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_10' name='txtDate_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_10' name='txtMedication_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_10' name='txtDosage_10' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_11' name='txtTime_11' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_11' name='txtDate_11' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_11' name='txtMedication_11' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_11' name='txtDosage_11' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_12' name='txtTime_12' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_12' name='txtDate_12' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_12' name='txtMedication_12' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_12' name='txtDosage_12' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_13' name='txtTime_13' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_13' name='txtDate_13' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_13' name='txtMedication_13' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_13' name='txtDosage_13' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_14' name='txtTime_14' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_14' name='txtDate_14' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_14' name='txtMedication_14' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_14' name='txtDosage_14' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_15' name='txtTime_15' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_15' name='txtDate_15' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_15' name='txtMedication_15' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_15' name='txtDosage_15' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_16' name='txtTime_16' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_16' name='txtDate_16' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_16' name='txtMedication_16' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_16' name='txtDosage_16' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_17' name='txtTime_17' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_17' name='txtDate_17' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_17' name='txtMedication_17' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_17' name='txtDosage_17' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_18' name='txtTime_18' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_18' name='txtDate_18' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_18' name='txtMedication_18' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_18' name='txtDosage_18' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_19' name='txtTime_19' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_19' name='txtDate_19' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_19' name='txtMedication_19' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_19' name='txtDosage_19' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='time' id='txtTime_20' name='txtTime_20' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_20' name='txtDate_20' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMedication_20' name='txtMedication_20' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDosage_20' name='txtDosage_20' className='add-only' /> </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>PSYCHOSOCIAL ASSESSMENT</h3></center>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Patient Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPatientName' name='txtPatientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>MR#:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Admission Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMr' name='txtMr' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Legal Status:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbVoluntary_1' name='cbVoluntary_1' className='add-only' value='Voluntary' /> Voluntary </td>
                        <td className='w-375'> <input type='checkbox' id='cbInvoluntaryPsychiatric' name='cbInvoluntaryPsychiatric' className='add-only' value='Involuntary Psychiatric Hold' /> Involuntary Psychiatric Hold </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbConservatorship' name='cbConservatorship' className='add-only' value='Conservatorship' /> Conservatorship (for Gravely Disabled Mentally Disordered Persons)
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Presenting Problems:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAdjustmentDisorder' name='cbAdjustmentDisorder' className='add-only' value='Adjustment Disorder' /> Adjustment Disorder </td>
                        <td className='w-250'><input type='checkbox' id='cbAnxietyDisorder' name='cbAnxietyDisorder' className='add-only' value='Anxiety Disorder' /> Anxiety Disorder </td>
                        <td className='w-250'><input type='checkbox' id='cbMoodDisorder' name='cbMoodDisorder' className='add-only' value='Mood Disorder' /> Mood Disorder</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPersonalityDisorder' name='cbPersonalityDisorder' className='add-only' value='Personality Disorder' /> Personality Disorder </td>
                        <td className='w-500'><input type='checkbox' id='cbSubstanceAbuse' name='cbSubstanceAbuse' className='add-only' value='Substance Abuse' /> Substance Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPresentingProblemsOther' name='cbPresentingProblemsOther' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPresentingProblemsOther' name='txtPresentingProblemsOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>History of Violence:</span>
                    <textarea id='txtViolence' name='txtViolence' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Suicide Potential:</span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbSignificantSense' name='cbSignificantSense' className='add-only' value='Significant sense of loss' /> Significant sense of loss (loved one, pet, employment)
                    <br />
                    <input type='checkbox' id='cbHardship' name='cbHardship' className='add-only' value='Significant sense of hardship' /> Significant sense of hardship (financial, legal)
                    <br />
                    <input type='checkbox' id='cbSeparation' name='cbSeparation' className='add-only' value='Significant sense of separation' /> Significant sense of separation
                    <br />
                    <input type='checkbox' id='cbSubstanceAbuse' name='cbSubstanceAbuse' className='add-only' value='Substance abuse' /> Substance abuse or dependence <br />
                    <input type='checkbox' id='cbSignificantUnstable' name='cbSignificantUnstable' className='add-only' value='Significant unstable' /> Significant unstable physical environment (below poverty level, lack of shelter, difficult foster placement, etc.)
                    <br />
                    <input type='checkbox' id='cbSuicideAttempt' name='cbSuicideAttempt' className='add-only' value='Family hx' /> Family hx of suicide attempt
                    <br />
                    <input type='checkbox' id='cbPreviousPt' name='cbPreviousPt' className='add-only' value='Previous pt' /> Previous pt suicide attempt
                    <br />
                    <input type='checkbox' id='cbSignificantDepression' name='cbSignificantDepression' className='add-only' value='Significant depression' /> Significant depression
                </p>
                <p className='w-750'> <span className='eleHeader'>Potential for Suicide:</span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='cbSuicide_Yes' name='cbSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbSuicide_No' name='cbSuicide' className='add-only' value='No' /> No <br />
                    If yes, refer to Social Service, place on close observation, notify physician
                </p>
                <p className='w-750'> <span className='eleHeader'>Current Suicidal Ideation/Plan:</span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='cbSuicidalIdeation_Yes' name='cbSuicidalIdeation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbSuicidalIdeation_No' name='cbSuicidalIdeation' className='add-only' value='No' /> No <br />
                    If yes, implement suicide precautions, notify physician, refer to Social Service
                </p>
                <p className='w-750'> <b> Past Psychiatric Treatment:</b>
                </p>
                <p className='w-750'> <span className='eleHeader'>Age at Onset:</span>
                    <input type='text' id='txtAgeAtOnset' name='txtAgeAtOnset' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'># of Hospitalizations:</span>
                    <textarea id='txtHospitalizations' name='txtHospitalizations' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>History of Substance Use:</span>
                    <input type='radio' id='cbSubstanceUse_Yes' name='cbSubstanceUse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbSubstanceUse_No' name='cbSubstanceUse' className='add-only' value='No' /> No <br />
                    (List each substance use)
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Substance:</span> </td>
                        <td className='w-125'> <span className='eleHeader'> Age of Onset:</span> </td>
                        <td className='w-125'> <span className='eleHeader'> Duration:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Intensity:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSubstance' name='txtSubstance' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtAgeOfOnset' name='txtAgeOfOnset' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtDuration' name='txtDuration' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIntensity' name='txtIntensity' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Patterns of use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Consequences of use:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPatternsOfUse' name='txtPatternsOfUse' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtConsequences' name='txtConsequences' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Types of previous treatment(s):</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Responses to treatment(s):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPreviousTreatment' name='txtPreviousTreatment' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtResponsesToTreatment' name='txtResponsesToTreatment' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Living Situation:</span>
                    <textarea id='txtLivingSituation' name='txtLivingSituation' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Insurance:</span>
                    <textarea id='txtInsurance' name='txtInsurance' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Source of Income:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Amount:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Debts:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSourceOfIncome' name='txtSourceOfIncome' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAmount' name='txtAmount' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDebts' name='txtDebts' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Recent Changes/Stressors:</span>
                    <textarea id='txtRecentChanges' name='txtRecentChanges' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Relevant Medical Consultations History:</span>
                    <textarea id='txtMedicalConsultations' name='txtMedicalConsultations' className='add-only'></textarea>
                </p> 
                <p className='w-750'><center><h3>SOCIAL HISTORY</h3></center>
                </p>
                <p className='w-750'> <span className='eleHeader'>Place of Birth:</span>
                    <input type='text' id='txtPlaceOfBirth' name='txtPlaceOfBirth' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Raised by:</span>
                    <input type='text' id='txtRaisedBy' name='txtRaisedBy' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Came to:</span>
                    <input type='text' id='txtCameTo' name='txtCameTo' className='add-only' />(state)
                </p>
                <p className='w-750'> <span className='eleHeader'>When/why:</span>
                    <textarea id='txtWhen' name='txtWhen' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Siblings/Family Structure:</span>
                    <textarea id='txtSiblings' name='txtSiblings' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Family History of Mental Illness:</span>
                    <input type='radio' id='cbFamilyHistory_Yes' name='cbFamilyHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbFamilyHistory_No' name='cbFamilyHistory' className='add-only' value='No' /> No <br />
                    If yes, relation:
                    <input type='text' id='txtFamilyHistoryIfYes' name='txtFamilyHistoryIfYes' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Family History of Drug and/or Alcohol Abuse:</span>
                    <input type='radio' id='cbHistoryOfDrug_Yes' name='cbHistoryOfDrug' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbHistoryOfDrug_No' name='cbHistoryOfDrug' className='add-only' value='No' /> No <br />
                    If yes, explain:
                    <input type='text' id='txtHistoryOfDrugIfYes' name='txtHistoryOfDrugIfYes' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Current Relationship w/Family:</span>
                    <textarea id='txtCurrentRelationship' name='txtCurrentRelationship' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Other Social Relationships:</span>
                    <textarea id='txtSocialRelationships' name='txtSocialRelationships' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Ethnic/Cultural Background:</span>
                    <textarea id='txtEthnic' name='txtEthnic' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Physical Abuse:</span>
                    <input type='radio' id='cbPhysicalAbuse_Yes' name='cbPhysicalAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbPhysicalAbuse_No' name='cbPhysicalAbuse' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Sexual Abuse as Perpetrator:</span>
                    <input type='radio' id='cbSexualAbuse_Yes' name='cbSexualAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbSexualAbuse_No' name='cbSexualAbuse' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Sexual Abuse as Victim:</span>
                    <input type='radio' id='cbVictim_Yes' name='cbVictim' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbVictim_No' name='cbVictim' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>If victim, is perpetrator known to patient?</span>
                    <input type='radio' id='cbIfVictim_Yes' name='cbIfVictim' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbIfVictim_No' name='cbIfVictim' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Have charges been brought?</span>
                    <input type='radio' id='cbcharges_Yes' name='cbcharges' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbcharges_No' name='cbcharges' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>Spiritual Orientation:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualBaptist' name='cbSpiritualBaptist' className='add-only' value='Baptist' /> Baptist </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualBuddhist' name='cbSpiritualBuddhist' className='add-only' value='Buddhist' /> Buddhist </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualCatholic' name='cbSpiritualCatholic' className='add-only' value='Catholic' /> Catholic </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpiritualChristian' name='cbSpiritualChristian' className='add-only' value='Christian' /> Christian </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualEastern' name='cbSpiritualEastern' className='add-only' value='Eastern Orthodox' /> Eastern Orthodox </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualHindu' name='cbSpiritualHindu' className='add-only' value='Hindu' /> Hindu </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualJehovahs' name='cbSpiritualJehovahs' className='add-only' value='Jehovahs Witness' /> Jehovah's Witness </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpiritualJewish' name='cbSpiritualJewish' className='add-only' value='Jewish' /> Jewish </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualMuslim' name='cbSpiritualMuslim' className='add-only' value='Muslim' />Muslim </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpiritualProtestant' name='cbSpiritualProtestant' className='add-only' value='Protestant' /> Protestant </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpiritualOther' name='cbSpiritualOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtSpiritualOther' name='txtSpiritualOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Religion of Family:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionBaptist' name='cbReligionBaptist' className='add-only' value='Baptist' /> Baptist </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionBuddhist' name='cbReligionBuddhist' className='add-only' value='Buddhist' /> Buddhist </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionCatholic' name='cbReligionCatholic' className='add-only' value='Catholic' /> Catholic </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbReligionChristian' name='cbReligionChristian' className='add-only' value='Christian' /> Christian </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionEastern' name='cbReligionEastern' className='add-only' value='Eastern' /> Eastern Orthodox </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionHindu' name='cbReligionHindu' className='add-only' value='Hindu' /> Hindu </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionJehovahs' name='cbReligionJehovahs' className='add-only' value='Jehovahs Witness' /> Jehovah's Witness </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbReligionJewish' name='cbReligionJewish' className='add-only' value='Jewish' /> Jewish </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionMuslim' name='cbReligionMuslim' className='add-only' value='Muslim' /> Muslim </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligionProtestant' name='cbReligionProtestant' className='add-only' value='Protestant' /> Protestant </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReligionOther' name='cbReligionOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtReligionOther' name='txtReligionOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Sexual Orientation:</span>
                    <input type='text' id='txtSexualOrientation' name='txtSexualOrientation' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Currently Sexually Active?:</span>
                    <input type='radio' id='cbSexuallyActive_Yes' name='cbSexuallyActive' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbSexuallyActive_No' name='cbSexuallyActive' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Awareness of HIV Protection:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGood' name='cbGood' className='add-only' value='Good' /> Good </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFair' name='cbFair' className='add-only' value='Fair' /> Fair </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAwarenessPoor' name='cbAwarenessPoor' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Accepts HIV Education:</span>
                    <input type='radio' id='cbHivEducation_Yes' name='cbHivEducation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbHivEducation_No' name='cbHivEducation' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Ever Married:</span>
                    <input type='radio' id='cbMarried_Yes' name='cbMarried' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbMarried_No' name='cbMarried' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Children:</span>
                    <input type='text' id='txtChildren' name='txtChildren' className='add-only' />
                </p> 
                <p className='w-750'> <span className='eleHeader'>Education Level:</span>
                    <input type='text' id='txtEducationLevel' name='txtEducationLevel' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Special Education History?:</span>
                    <input type='radio' id='cbHistory_Yes' name='cbHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbHistory_No' name='cbHistory' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Employment History:</span>
                    <textarea id='txtEmploymentHistory' name='txtEmploymentHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Military Service:</span>
                    <textarea id='txtMilitaryService' name='txtMilitaryService' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Criminal History:</span>
                    <input type='radio' id='cbCriminalHistory_Yes' name='cbCriminalHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='cbCriminalHistory_No' name='cbCriminalHistory' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>Parole/Probation Officer:</span>
                    <textarea id='txtProbationOfficer' name='txtProbationOfficer' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Personal Strengths/Assets:</span>
                    <textarea id='txtPersonalStrengths' name='txtPersonalStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Motivation for Change/Treatment Acceptance:</span>
                    <textarea id='txtTreatmentAcceptance' name='txtTreatmentAcceptance' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Recreation/Leisure Activities:</span>
                    <textarea id='txtLeisureActivities' name='txtLeisureActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Peer Group:</span>
                    <textarea id='txtPeerGroup' name='txtPeerGroup' className='add-only'></textarea>
                </p>
                <p className='w-750'><center><h4>MENTAL STATUS</h4></center>
                </p>
                <p className='w-750'> <span className='eleHeader'>Appearance:</span>
                    <textarea id='txtAppearance' name='txtAppearance' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Altitude:</span>
                    <textarea id='txtAltitude' name='txtAltitude' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Orientation:</span>
                    <textarea id='txtOrientation' name='txtOrientation' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Motor Activity:</span>
                    <textarea id='txtMotorActivity' name='txtMotorActivity' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Mood:</span>
                    <textarea id='txtMood' name='txtMood' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Affect:</span>
                    <textarea id='txtAffect' name='txtAffect' className='add-only'></textarea>
                </p> 
                <p className='w-750'> <span className='eleHeader'>Speech:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbVoluntary' name='cbVoluntary' className='add-only' value='Voluntary' /> Appropriate </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbDisorganized' name='cbDisorganized' className='add-only' value='Disorganized' /> Disorganized </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbHyperverbal' name='cbHyperverbal' className='add-only' value='Hyperverbal' /> Hyperverbal </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value='Incoherent' /> Incoherent </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbLoud' name='cbLoud' className='add-only' value='Loud' /> Loud </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbMumbled' name='cbMumbled' className='add-only' value='Mumbled' /> Mumbled </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbMute' name='cbMute' className='add-only' value='Mute' /> Mute </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbNeologisms' name='cbNeologisms' className='add-only' value='Neologisms' /> Neologisms </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' /> Pressured </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='Slurred' /> Slurred </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSoft' name='cbSoft' className='add-only' value='Soft' /> Soft </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbStutter' name='cbStutter' className='add-only' value='Stutter' /> Stutter </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSpeechOther' name='cbSpeechOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtSpeechOther' name='txtSpeechOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Sleep:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbExcessive' name='cbExcessive' className='add-only' value='Excessive' /> Excessive </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbInsufficient' name='cbInsufficient' className='add-only' value='Insufficient' /> Insufficient </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbInterrupted' name='cbInterrupted' className='add-only' value='Interrupted' /> Interrupted </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbIrregular' name='cbIrregular' className='add-only' value='Irregular' /> Irregular </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSleepPoor' name='cbSleepPoor' className='add-only' value='Poor' /> Poor </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbPrimaryInsomnia' name='cbPrimaryInsomnia' className='add-only' value='Primary insomnia' /> Primary insomnia </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbTerminalInsomnia' name='cbTerminalInsomnia' className='add-only' value='Terminal insomnia' /> Terminal insomnia </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSleepOther' name='cbSleepOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtSleepOther' name='txtSleepOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Perceptions: </b>
                </p>
                <p className='w-750'> <span className='eleHeader'>AH/VH:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbAccusatory' name='cbAccusatory' className='add-only' value='Accusatory' /> Accusatory </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbCommandType' name='cbCommandType' className='add-only' value='Command type' /> Command type </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbDerogatory' name='cbDerogatory' className='add-only' value='Derogatory' /> Derogatory </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPersecutory' name='cbPersecutory' className='add-only' value='Persecutory' /> Persecutory </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReligious' name='cbReligious' className='add-only' value='Religious' /> Religious </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbFlares' name='cbFlares' className='add-only' value='Flares' /> Flares/lights </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRecognizable' name='cbRecognizable' className='add-only' value='Recognizable' /> Recognizable </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbTactile' name='cbTactile' className='add-only' value='Tactile' /> Tactile </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPerceptionsOther' name='cbPerceptionsOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtPerceptionsOther' name='txtPerceptionsOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Thought Content: </b>
                </p>
                <p className='w-750'> <span className='eleHeader'>DEL:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBizarre' name='cbBizarre' className='add-only' value='Bizarre' /> Bizarre </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDeath' name='cbDeath' className='add-only' value='Death' /> Death </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbErotomanic' name='cbErotomanic' className='add-only' value='Erotomanic' /> Erotomanic </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGrandiose' name='cbGrandiose' className='add-only' value='Grandiose' /> Grandiose </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHopeless' name='cbHopeless' className='add-only' value='Hopeless' /> Hopeless/helpless </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdeasOfReference' name='cbIdeasOfReference' className='add-only' value='Ideas of reference' /> Ideas of reference </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbParanoid' name='cbParanoid' className='add-only' value='Paranoid' /> Paranoid </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPersecutory' name='cbPersecutory' className='add-only' value='Persecutory' /> Persecutory </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreoccupied' name='cbPreoccupied' className='add-only' value='Preoccupied' /> Preoccupied </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSomatic' name='cbSomatic' className='add-only' value='Somatic' /> Somatic </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicide' name='cbSuicide' className='add-only' value='Suicide' /> Suicide </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtBroadcasting' name='cbThoughtBroadcasting' className='add-only' value='Thought Broadcasting' />Thought Broadcasting/insertion</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbThoughtContentOther' name='cbThoughtContentOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                            <td className='w-375'> <input type='text' id='txtThoughtContentOther' name='txtThoughtContentOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Thought Process:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbCircular' name='cbCircular' className='add-only' value='Circular' /> Circular </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbDisorganized' name='cbDisorganized' className='add-only' value='Disorganized' />Disorganized </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbFixedIdeas' name='cbFixedIdeas' className='add-only' value='Fixed ideas' /> Fixed ideas </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbLoose' name='cbLoose' className='add-only' value='Loose' /> Loose </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbPerseverating' name='cbPerseverating' className='add-only' value='Perseverating' /> Perseverating </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRuminating' name='cbRuminating' className='add-only' value='Ruminating' /> Ruminating </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtBlocking' name='cbThoughtBlocking' className='add-only' value='Thought Blocking' /> Thought blocking </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbThoughtProcessOther' name='cbThoughtProcessOther' className='add-only' value='Other' /> Other: </td>
                            </tr>
                            <tr>
                        <td className='w-375'> <input type='text' id='txtcbThoughtProcessOther' name='txtcbThoughtProcessOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Memory: </b>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Immediate</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Recent</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Remote</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtImmediate' name='txtImmediate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRecent' name='txtRecent' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRemote' name='txtRemote' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Attention:</span>
                    <textarea id='txtAttention' name='txtAttention' className='add-only'></textarea>
                </p>
                <p className='w-750'> <b> Abstraction: </b>
                </p>
                <p className='w-750'> <span className='eleHeader'>Proverb:</span>
                    <textarea id='txtProverb' name='txtProverb' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Judgment/Insight:</span>
                    <textarea id='txtJudgment' name='txtJudgment' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Impression of Intelligence:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAverage' name='cbAverage' className='add-only' value='Average' /> Average </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBelowAverage' name='cbBelowAverage' className='add-only' value='cbBelow Average' />Below Average </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAboveAverage' name='cbAboveAverage' className='add-only' value='Above Average' />Above Average </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntellectualDisabilities' name='cbIntellectualDisabilities' className='add-only' value='Intellectual Disabilities' /> Intellectual Disabilities </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>

            </div>
        </form >

    )
}







